<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-btn
        class="title primary"
        ourlined tile @click="openPicker()">
      {{$helper.month_format_short(dateFrom)}}
    </v-btn>
    <v-dialog v-model="isPickingDate"
              width="350"
    >
      <v-card>
        <v-card-title>เลือกเดือน
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="text-center">
              <v-date-picker
                  v-model="monthFrom"
                  locale="th"
                  type="month"
              ></v-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="gray" class="mr-4" @click="isPickingDate=false">
            ยกเลิก
          </v-btn>
          <v-btn fab tile @click="apply()" class="close-button"
                 color="primary">
           เลืิอก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script lang="ts">

  import {Component, Prop, Vue} from 'vue-property-decorator'

  @Component({
    components: {},
  })
  export default class DatePickerMonth extends Vue {
    @Prop()
    public dateFrom!: string
    @Prop()
    public dateTo!: string

    @Prop({
      default: () => {
      },
    }) onApply: Function

    isPickingDate = false

    monthFrom = ''

    openPicker() {
      this.monthFrom = this.dateFrom.substr(0, 7)
      this.isPickingDate = true
    }

    apply() {
      this.isPickingDate = false

      this.dateFrom = this.monthFrom + '-01'

      var tzoffset = (new Date()).getTimezoneOffset() * 60000
      var tmpDateFrom = new Date(this.dateFrom)
      tmpDateFrom.setMonth(tmpDateFrom.getMonth() + 1)
      tmpDateFrom.setDate(0)
      this.dateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)

      this.onApply(this.dateFrom, this.dateTo)
    }
  }

</script>
